// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".insights_box-module__inner--HmdLa{margin-top:8px;margin-bottom:8px;width:100%;padding:8px 0px;color:#616161;border-top:1px solid #c6ced5;border-bottom:1px solid #c6ced5}.insights_box-module__innerNoStroke--1brdg{margin-top:8px;margin-bottom:8px;width:100%;padding:8px 0px;color:#616161}\n", ""]);
// Exports
exports.locals = {
	"inner": "insights_box-module__inner--HmdLa",
	"innerNoStroke": "insights_box-module__innerNoStroke--1brdg"
};
module.exports = exports;
